import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { SkeletonAccountScreen } from 'structure/account/loading-screen';
import { accountModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonAccountScreen />;
}

export default function AccountLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/account/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'account',
        instanceKey: 'one',
        moduleQuery: accountModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
